import { breakpointValues, spacing } from "@magicbi/ui-library";

/** Minimum touch target on phones, 44px. ui-library token gap: no rem touch-target token exists (spacing[11] is px). */
export const touchTargetMin = "2.75rem";

/**
 * Page gutter as one CSS declaration block: spacing[4] (16px) on phone, spacing[6] (24px) from md,
 * spacing[8] (32px) from lg. Use in place of hard-coded side padding: `${pageGutterCss()}`.
 */
export const pageGutterCss = (property: string = "padding-inline"): string => `
  ${property}: ${spacing[4]};
  @media (min-width: ${breakpointValues.md}px) {
    ${property}: ${spacing[6]};
  }
  @media (min-width: ${breakpointValues.lg}px) {
    ${property}: ${spacing[8]};
  }
`;

/**
 * Auto-fit grid as one CSS declaration block: as many columns of at least `minItem` as fit, one column when the
 * container is narrower than `minItem`. Use in place of fixed `repeat(N, ...)` tracks: `${autoGridCss("20rem")}`.
 */
export const autoGridCss = (minItem: string): string => `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, ${minItem}), 1fr));
`;

/** The single-column phone layout: 640px (40rem) and narrower. Use as `${phoneMedia} { ... }`. */
export const phoneMedia = "@media (max-width: 40rem)";

/** Fixed picture ratio for card media on phones, so a live chart can never set the card's height. */
export const phoneMediaRatio = "16 / 9";

/** Right-edge fade for a row that scrolls sideways on phones, so clipped chips read as "more this way". */
export const sideScrollFadeCss = (fade: string = spacing[8]): string => `
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
  -webkit-mask-image: linear-gradient(90deg, #000 calc(100% - ${fade}), transparent);
  mask-image: linear-gradient(90deg, #000 calc(100% - ${fade}), transparent);
`;

/** Below this width (phones, under md) the story page's side rails become rows. Matches useViewportClass "phone". */
export const belowTabletMedia = `@media (max-width: ${breakpointValues.md - 1}px)`;

/** Phones and tablets (under lg). Matches useViewportClass "phone" and "tablet". */
export const belowDesktopMedia = `@media (max-width: ${breakpointValues.lg - 1}px)`;

/** End room a bar keeps free for the floating assistant button at the bottom-right corner (64px). */
export const floatingActionClearance = spacing[16];
